import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "backupCamera"
const BackupCameraIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M22.5 5.25H19.993C19.396 5.25 18.823 5.487 18.4 5.91L16.061 8.25H22.5V9.75H12C11.379 9.75 10.875 10.254 10.875 10.875V12.375H12C12.414 12.375 12.75 12.711 12.75 13.125S12.414 13.875 12 13.875H10.875V16.125H13.97C14.302 14.831 15.477 13.875 16.875 13.875S19.448 14.831 19.781 16.125H22.5V17.625H19.78C19.449 18.919 18.274 19.875 16.876 19.875S14.303 18.919 13.97 17.625H10.875C10.047 17.625 9.375 16.953 9.375 16.125V10.875C9.375 9.425 10.55 8.25 12 8.25H13.94L17.34 4.849C18.045 4.145 18.999 3.75 19.994 3.75H22.5zM16.875 15.375C16.047 15.375 15.375 16.047 15.375 16.875S16.047 18.375 16.875 18.375 18.375 17.703 18.375 16.875 17.703 15.375 16.875 15.375"
            clipRule="evenodd"
          />
          <path d="M3.697 6.697C3.989 6.404 4.464 6.404 4.757 6.697 5.05 6.989 5.05 7.464 4.757 7.757 4.2 8.314 3.76 8.976 3.457 9.704 3.156 10.432 3 11.212 3 12S3.156 13.568 3.457 14.296 4.2 15.686 4.757 16.243C5.05 16.536 5.05 17.01 4.757 17.303S3.99 17.597 3.697 17.304C3 16.607 2.447 15.78 2.07 14.87 1.694 13.96 1.5 12.985 1.5 12S1.694 10.04 2.07 9.13C2.448 8.22 3 7.393 3.698 6.697" />
          <path d="M5.447 8.765C5.67 8.416 6.134 8.315 6.483 8.538 6.83 8.76 6.933 9.225 6.71 9.573 6.237 10.313 5.99 11.174 6 12.051S6.277 13.784 6.766 14.511C6.997 14.856 6.906 15.322 6.563 15.553S5.752 15.692 5.522 15.35C4.869 14.378 4.514 13.238 4.5 12.069 4.487 10.898 4.816 9.75 5.447 8.764" />
        </svg>
      }
    </span>
  )
}
export default BackupCameraIcon
